export default __webpack_public_path__ + "static/media/SPACE-BNB.feef124b.png";